<template>
  <v-container fluid>
    <v-progress-linear v-if="$vars.loading" indeterminate class="primary--text loader"></v-progress-linear>
    <v-toolbar dense flat>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            @click.stop="(showRechnungerstellen = true) && (rechnungErstellenData = rechnungErstellenDataMaske)"
            v-on="on"
            ><v-icon>add</v-icon></v-btn
          >
        </template>
        <span>Neue Rechnung</span>
      </v-tooltip>
      <!-- <v-btn small outlined class="ml-3" text @click="showRechnungenVersenden = true">Test: Rechnungen Versenden</v-btn> -->
      <span v-if="rechnungsKategorienen[tab]">
        <dialogRechnungenVersenden
          :visible.sync="showRechnungenVersenden"
          :rechnungen="alleRechnungen.filter((item) => item.status === rechnungsKategorienen[tab].status)"
          @close="showRechnungenVersenden = false"
        />
      </span>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon @click="showSepaDateien = true" v-on="on"><v-icon>request_quote</v-icon></v-btn>
          </template>
          <span>Sepa Dateien</span>
        </v-tooltip>
      </v-toolbar-items>
      <v-toolbar-items>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon @click.stop="showExport = !showExport" v-on="on"><v-icon>file_download</v-icon></v-btn>
          </template>
          <span>Export</span>
        </v-tooltip>
      </v-toolbar-items>
      <v-toolbar-items>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon @click.stop="showStatistik = !showStatistik" v-on="on"><v-icon>insights</v-icon></v-btn>
          </template>
          <span>Statistik</span>
        </v-tooltip>
      </v-toolbar-items>
    </v-toolbar>
    <v-divider></v-divider>

    <v-container>
      {{ kasse ? "" : "Rechnungen konnten nicht geladen werden. Bitte zur Startseite gehen." }}
      <v-row no-gutters>
        <v-col cols="9">
          <v-tabs v-model="tab" class="mb-2" center-active show-arrows background-color="transparent">
            <v-tab v-if="rechnungsKategorienen.length === 0">Keine Rechnungen vorhanden</v-tab>
            <v-tab class="caption" v-for="item in rechnungsKategorienen" :key="item.status" v-if="item.anzahl > 0"
              >{{ item.status }} ({{ item.anzahl }})</v-tab
            >
          </v-tabs>
        </v-col>
        <v-col cols="3" class="d-flex justify-end align-center">
          <v-responsive max-width="300" class="mr-4">
            <v-text-field
              class="rounded-lg"
              dense
              flat
              solo
              hide-details
              v-model="search"
              append-icon="search"
              placeholder="Rechnungen durchsuchen"
              clearable
              @keydown.esc="search = ''"
            ></v-text-field>
          </v-responsive>
        </v-col>
      </v-row>
    </v-container>

    <v-container>
      <v-card class="rounded-lg">
        <v-tabs-items v-model="tab" class="transparent">
          <v-tab-item v-for="item in rechnungsKategorienen" :key="item.status" v-if="item.anzahl > 0">
            <rechnungen-liste :status="item.status" :kasse="kasse" :search="search"></rechnungen-liste>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-container>

    <v-dialog
      v-model="showExport"
      width="40%"
      height="100%"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      persistent
      scrollable
    >
      <v-card>
        <v-card-title>
          Export Rechnungen {{ kasse }}
          <v-spacer></v-spacer>
          <v-btn icon @click="showExport = false"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-progress-linear v-if="$vars.loading" indeterminate class="primary--text loader"></v-progress-linear>
        <v-divider></v-divider>
        <v-card-text>
          Die Rechnungen werden derzeit ausschließlich mit UTF-8 exportiert. Daher ist die csv-Datei evtl nicht in allen
          Tabellenprogrammen gleich dargestellt.
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-btn text @click="showExport = false">Schließen</v-btn>
          <v-spacer></v-spacer>
          <v-btn class="primary" @click="exportData()"
            ><v-icon class="mr-2">file_download</v-icon>Daten herunterladen</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showStatistik"
      width="80%"
      height="100%"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      persistent
      scrollable
    >
      <v-card class="pa-0 ma-0">
        <v-card-title>
          Zusammenfassung Rechnungspositionen
          <v-spacer></v-spacer>
          <v-btn icon @click="showStatistik = false"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-progress-linear v-if="$vars.loading" indeterminate class="primary--text loader"></v-progress-linear>

        <v-divider></v-divider>
        <v-card-text class="pa-0 ma-0">
          <v-row class="mt-4 mb-4">
            <v-col cols="6">
              <v-menu
                ref="filter.von"
                v-model="menu3"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="date"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    dense
                    outlined
                    hide-details
                    v-model="formatDatumVon"
                    label="Datum von"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  prev-icon="keyboard_arrow_left"
                  next-icon="keyboard_arrow_right"
                  v-model="filter.von"
                  locale="de-de"
                  first-day-of-week="1"
                  @input="menu3 = false"
                  no-title
                  scrollable
                >
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="6">
              <v-menu
                ref="filter.von"
                v-model="menu4"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="date"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    dense
                    outlined
                    hide-details
                    v-model="formatDatumBis"
                    label="Datum bis"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  prev-icon="keyboard_arrow_left"
                  next-icon="keyboard_arrow_right"
                  v-model="filter.bis"
                  locale="de-de"
                  first-day-of-week="1"
                  @input="menu4 = false"
                  no-title
                  scrollable
                >
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12">
              Diese Ansicht zeigt eine Zusammenfassung der Rechnungspositionen aller gezahlten Rechnungen der
              {{ kasse }} im Zeitraum vom {{ $filters.date(filter.von, "DD.MM.YYYY") }} bis
              {{ $filters.date(filter.bis, "DD.MM.YYYY") }}. Sie unterteilt die Rechnungen in Überweisungen und
              Sepa-Rechnungen.
            </v-col>
            <v-col cols="6">
              <span class="title">Rechnungen per Überweisung:</span>
              <v-simple-table dense fixed-header height="200px">
                <thead>
                  <tr>
                    <th class="text-left">Bezeichnung</th>
                    <th class="text-right">Betrag</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in positionen.normal" :key="index">
                    <td>{{ index }}</td>
                    <td class="text-right">{{ item.betrag | money }}</td>
                  </tr>
                  <tr>
                    <th class="text-left">Summe</th>
                    <th class="text-right">{{ positionen.normal_summe | money }}</th>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
            <v-col cols="6">
              <span class="title">Rechnungen per SEPA:</span>
              <v-simple-table dense fixed-header height="200px">
                <thead>
                  <tr>
                    <th class="text-left">Bezeichnung</th>
                    <th class="text-right">Betrag</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in positionen.sepa" :key="index">
                    <td>{{ index }}</td>
                    <td class="text-right">{{ item.betrag | money }}</td>
                  </tr>
                  <tr>
                    <th class="text-left">Summe</th>
                    <th class="text-right">{{ positionen.sepa_summe | money }}</th>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showStatistik = false">Schließen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showRechnungerstellen"
      width="70%"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      persistent
      scrollable
      content-class="elevation-0"
    >
      <v-card class="rounded-xl pa-0 ma-0" height="80vh">
        <v-card-title>
          Rechnungen erstellen
          <v-spacer></v-spacer>
          <v-btn icon @click="(showRechnungerstellen = false) && ($vars.loading = false)"><v-icon>close</v-icon></v-btn>
          <v-progress-linear v-if="$vars.loading" indeterminate class="primary--text loader"></v-progress-linear>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pa-0 ma-0">
          <v-stepper v-model="e1" flat outlined class="pa-0 ma-0" alt-labels>
            <v-stepper-header>
              <v-stepper-step :complete="e1 > 1" step="1">Kontakte<br />auswählen</v-stepper-step
              ><v-divider></v-divider>
              <v-stepper-step :complete="e1 > 2" step="2">Rechnungs-<br />details</v-stepper-step
              ><v-divider></v-divider>
              <v-stepper-step :complete="e1 > 3" step="3">Rechnungs-<br />positionen</v-stepper-step
              ><v-divider></v-divider> <v-stepper-step :complete="e1 > 4" step="4">Zusammenfassung</v-stepper-step
              ><v-divider></v-divider>
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content step="1">
                <v-row>
                  <v-col cols="12" class="pt-4">
                    <v-autocomplete
                      hide-details
                      dense
                      deletable-chips
                      multiple
                      chips
                      small-chips
                      clearable
                      required
                      outlined
                      clear-icon="delete"
                      v-model="rechnungErstellenData.bbrbbr"
                      :items="bundesbruder"
                      label="Kontakte auswählen"
                    >
                      <template v-slot:append>
                        <v-chip small label>{{
                          rechnungErstellenData.bbrbbr ? rechnungErstellenData.bbrbbr.length : 0
                        }}</v-chip>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12">
                    Gruppen nach Mitgliedsstatus hinzufügen: <br />
                    <v-btn
                      small
                      class="mr-2"
                      v-for="(item, index) in gruppen"
                      :key="index"
                      @click="gruppeAdd(item.status)"
                      >{{ item.status }}</v-btn
                    >
                    <v-btn small class="mr-2" @click="gruppeAdd('Alle')">Alle</v-btn>
                  </v-col>
                  <v-col cols="12">
                    <v-icon>info</v-icon>
                    Bsp: Sollen Rechnungen an einen Teil der Mitglieder gestellt werden kann einfach "Alle" ausgewählt
                    werden. Im weiteren Prozess erhalten nur Kontakte, welche einen Betrag eingetragen haben eine
                    Rechnung die mehr als 0€ beträgt. Rechnung die 0€ betragen werden nicht erstellt.
                  </v-col>
                </v-row>
              </v-stepper-content>

              <v-stepper-content step="2">
                <v-card height="480px">
                  <v-row>
                    <v-col cols="6" md="8" class="pt-4 py-0"
                      ><v-text-field
                        dense
                        outlined
                        required
                        v-model="rechnungErstellenData.titel"
                        label="Rechnungstitel"
                      ></v-text-field
                    ></v-col>
                    <v-col cols="6" md="2" class="pt-4 py-0">
                      <v-menu
                        ref="rechnungErstellenData.datum"
                        v-model="menu1"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="date"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            dense
                            outlined
                            v-model="formatDatum"
                            label="Rechnungsdatum"
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          prev-icon="keyboard_arrow_left"
                          next-icon="keyboard_arrow_right"
                          v-model="rechnungErstellenData.datum"
                          locale="de-de"
                          first-day-of-week="1"
                          @input="menu1 = false"
                          no-title
                          scrollable
                        >
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="6" md="2" class="pt-4 py-0">
                      <v-menu
                        ref="rechnungErstellenData.zahlbar_bis"
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="date"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            dense
                            outlined
                            v-model="formatZahlbar_bis"
                            label="Zahlbar bis"
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          prev-icon="keyboard_arrow_left"
                          next-icon="keyboard_arrow_right"
                          v-model="rechnungErstellenData.zahlbar_bis"
                          locale="de-de"
                          first-day-of-week="1"
                          @input="menu2 = false"
                          no-title
                          scrollable
                        >
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col class="py-0" cols="12" md="6">
                      <v-textarea
                        rows="12"
                        v-model="rechnungErstellenData.freitext"
                        label="Freitext"
                        hint="<<Rechnungstitel>>, <<Rechnungsdatum>>, <<Rechnungsnummer>>, <<Briefanrede>>, <<Vorname>>, <<Nachname>>, <<Rechnungsbetrag>>, <<Zahlbar_bis>>, <<Absender Name>>"
                        outlined
                      ></v-textarea>
                    </v-col>
                    <v-col class="py-0" cols="12" md="6">
                      <v-textarea
                        rows="12"
                        v-model="rechnungErstellenData.freitext_Sepa"
                        label="Freitext SEPA"
                        hint="<<Rechnungstitel>>, <<Rechnungsdatum>>, <<Rechnungsnummer>>, <<Briefanrede>>, <<Vorname>>, <<Nachname>>, <<Rechnungsbetrag>>, <<Zahlbar_bis>>, <<Absender Name>>"
                        outlined
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>

              <v-stepper-content step="3">
                <v-card height="480px">
                  <v-row>
                    <v-col cols="8">
                      <v-btn
                        outlined
                        @click="
                          (showRechnungerstellenPositionAdd = true) &&
                            (rechnungErstellenPositionAddData = { neu: true, anzahl: 1, betrag: '', betragArray: [] })
                        "
                        ><v-icon>add</v-icon>Position</v-btn
                      >
                      <v-btn
                        outlined
                        @click="
                          (showRechnungerstellenVeranstaltungAdd = true) &&
                            (rechnungerstellenVeranstaltungAddData = {
                              neu: true,
                              anzahl: 1,
                              betrag: 0,
                              betragBegleitung: 0,
                              betragArray: [],
                            })
                        "
                        ><v-icon>add</v-icon>Veranstaltung</v-btn
                      >
                      <v-btn
                        outlined
                        @click="
                          (showRechnungerstellenCouleurstrafenAdd = true) &&
                            (rechnungerstellenCouleurstrafenAddData = {
                              neu: true,
                              anzahl: 1,
                              bezeichnung: 'Couleurstrafen',
                              betrag: 0,
                              betragArray: [],
                            })
                        "
                        ><v-icon>add</v-icon>Couleurstrafen</v-btn
                      >
                    </v-col>
                    <v-col cols="4">
                      <div class="subtitle-2 text-right mt-2">Summe: {{ rechnungErstellenDataSumme | money }}</div>
                    </v-col>
                    <!-- <v-col cols="4">
                    <v-switch hide-details dense v-model="switchTabelle.positionen" label="Positionen anzeigen"></v-switch>
                    <v-switch hide-details dense v-model="switchTabelle.rechnungen" label="Rechnungen anzeigen"></v-switch>
                  </v-col> -->
                    <v-col :cols="switchTabelle.rechnungen ? 6 : 12" v-if="switchTabelle.positionen">
                      <v-card outlined>
                        <v-simple-table dense fixed-header height="400">
                          <thead>
                            <tr>
                              <th width="20px" class="text-left"></th>
                              <th class="text-left">Was</th>
                              <th class="text-left">Anz</th>
                              <th class="text-right">Betrag von-bis</th>
                              <th class="text-right">Summe</th>
                              <!-- <th width="20px" class="text-right"></th> -->
                              <th width="20px" class="text-right"></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(item, index) in rechnungErstellenData.positionen" :key="index">
                              <td width="20px">{{ index + 1 }}.</td>
                              <td>{{ item.bezeichnung }}</td>
                              <td>{{ item.rechnungen.length }}</td>
                              <td class="text-right" v-if="item.min !== item.max">
                                {{ item.min | money }} - {{ item.max | money }}
                              </td>
                              <td class="text-right" v-else>{{ item.min | money }}</td>
                              <td class="text-right">{{ item.summe | money }}</td>
                              <!-- <td width="20px"><v-btn disabled @click="editRechnungErstellenPosition(item)" small icon><v-icon>edit</v-icon></v-btn></td> -->
                              <td width="20px">
                                <v-btn @click="deleteRechnungErstellenPosition(item)" small icon
                                  ><v-icon>delete</v-icon></v-btn
                                >
                              </td>
                            </tr>
                          </tbody>
                        </v-simple-table>
                      </v-card>
                    </v-col>
                    <v-col :cols="switchTabelle.positionen ? 6 : 12" v-if="switchTabelle.rechnungen">
                      <v-card outlined>
                        <v-simple-table dense fixed-header height="400">
                          <thead>
                            <tr>
                              <th width="20px" class="text-left"></th>
                              <th class="text-left">Wer</th>
                              <th class="text-right">Anz Positionen</th>
                              <th class="text-right">Summe</th>
                              <!-- <th width="20px" class="text-right"></th> -->
                              <th width="20px" class="text-right"></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(item, index) in rechnungErstellenData.rechnungen" :key="index">
                              <td width="20px">{{ index + 1 }}.</td>
                              <td>{{ $filters.user(item.bbrID, bbrbbr) }}</td>
                              <td class="text-right">{{ item.positionen.length }}</td>
                              <td class="text-right">{{ item.summe | money }}</td>
                              <!-- <td width="20px"><v-btn disabled @click="editRechnungErstellenRechnung(item)" small icon><v-icon>edit</v-icon></v-btn></td> -->
                              <td width="20px">
                                <v-btn @click="deleteRechnungErstellenRechnung(item)" small icon
                                  ><v-icon>delete</v-icon></v-btn
                                >
                              </td>
                            </tr>
                          </tbody>
                        </v-simple-table>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>

              <v-stepper-content step="4">
                <v-card height="480px">
                  <v-row>
                    <v-col cols="3">
                      <v-card></v-card>
                    </v-col>
                    <v-col cols="12">
                      <v-card outlined>
                        <v-card-title>
                          <v-spacer></v-spacer>
                          <v-btn icon :disabled="indexRechnung < 1" @click="indexRechnung -= 1"
                            ><v-icon>keyboard_arrow_left</v-icon></v-btn
                          >
                          <div class="text-center subtitle-2">
                            Rechnung {{ indexRechnung + 1 }} von {{ kontrolleRechnungen.length }}
                          </div>
                          <v-btn
                            icon
                            :disabled="indexRechnung > kontrolleRechnungen.length - 2"
                            @click="indexRechnung += 1"
                            ><v-icon>keyboard_arrow_right</v-icon></v-btn
                          >
                          <v-spacer></v-spacer>
                        </v-card-title>
                        <v-simple-table dense fixed-header height="200">
                          <thead>
                            <tr>
                              <th width="20px" class="text-left"></th>
                              <th class="text-left">Was</th>
                              <th class="text-right">Anzahl</th>
                              <th class="text-right">Betrag</th>
                              <th class="text-right">Summe</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(item, index) in kontrolleRechnungen[indexRechnung].positionen" :key="index">
                              <td width="20px">{{ index + 1 }}.</td>
                              <td>{{ item.bezeichnung }}</td>
                              <td class="text-right">{{ item.anzahl }}</td>
                              <td class="text-right">{{ item.betrag | money }}</td>
                              <td class="text-right">{{ item.summe | money }}</td>
                            </tr>
                          </tbody>
                        </v-simple-table>
                        <v-divider></v-divider>
                        <v-card-actions>
                          <v-row class="my-1 mx-1 subtitle-2">
                            <v-col cols="10">
                              {{ $filters.user(kontrolleRechnungen[indexRechnung].bbrID, bbrbbr) }}
                            </v-col>
                            <v-col cols="2" class="text-right">
                              {{ kontrolleRechnungen[indexRechnung].summe | money }}
                            </v-col>
                          </v-row>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-btn rounded text @click.stop="showRechnungerstellen = false">Abbrechen</v-btn>
          <v-spacer></v-spacer>
          <div v-if="e1 === 4" class="text-right">
            <v-btn rounded text @click="e1 = e1 - 1">Zurück</v-btn>
            <v-btn rounded color="primary" @click="rechnungErstellen()">Rechnungen stellen</v-btn>
          </div>
          <div v-else class="text-right">
            <v-btn rounded text v-if="e1 > 1" @click="e1 = e1 - 1">Zurück</v-btn>
            <v-btn rounded color="primary" @click="e1 = e1 + 1">Weiter</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showRechnungerstellenPositionAdd"
      width="60%"
      height="100%"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      persistent
      scrollable
    >
      <v-card class="pa-0 ma-0" height="480px">
        <v-card-title>
          Neue Position hinzufügen
          <v-spacer></v-spacer>
          <v-btn icon @click="showRechnungerstellenPositionAdd = false"><v-icon>close</v-icon></v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pa-0 pt-4">
          <v-row>
            <v-col cols="3">
              <v-row>
                <v-col cols="12" class="px-0"
                  ><v-text-field
                    hide-details
                    dense
                    v-model="rechnungErstellenPositionAddData.bezeichnung"
                    label="Bezeichnung"
                    outlined
                  ></v-text-field
                ></v-col>
                <v-col cols="12" class="px-0"
                  ><v-text-field
                    hide-details
                    dense
                    v-model="rechnungErstellenPositionAddData.anzahl"
                    type="number"
                    label="Anzahl"
                    outlined
                  ></v-text-field
                ></v-col>
                <v-col cols="12" class="px-0"
                  ><v-text-field
                    hide-details
                    @change="changePositionDataInput('betrag')"
                    dense
                    v-model="rechnungErstellenPositionAddData.betrag"
                    type="number"
                    label="Betrag"
                    outlined
                  ></v-text-field
                ></v-col>
                <v-col cols="12" class="px-0"
                  ><v-autocomplete
                    hide-details
                    @change="changePositionDataInput('kontaktfeld')"
                    dense
                    :items="kontaktfelder"
                    v-model="rechnungErstellenPositionAddData.kontaktfeld"
                    label="Kontaktfeld"
                    outlined
                  ></v-autocomplete
                ></v-col>
                <v-col cols="12" class="px-0"
                  ><v-btn block outlined @click="changePositionDataInput('null')">Alle 0€</v-btn></v-col
                >
              </v-row>
            </v-col>
            <v-col cols="9">
              <v-card outlined>
                <v-data-table
                  :items-per-page="rechnungErstellenPositionAddData.betragArray.length"
                  dense
                  fixed-header
                  height="290"
                  hide-default-footer
                  :items="rechnungErstellenPositionAddData.betragArray"
                  :headers="headersData"
                >
                  <template v-slot:item="{ item }">
                    <tr>
                      <td width="20px">{{ item.id + 1 }}</td>
                      <td>{{ $filters.user(item.bbr, bbrbbr) }}</td>
                      <td width="150px">
                        <v-text-field
                          dense
                          hide-details
                          class="text-right"
                          prefix="€"
                          v-model="item.betrag"
                          label="Betrag"
                          single-line
                          solo
                          flat
                          reverse
                        ></v-text-field>
                      </td>
                      <td width="20px"><v-icon>delete</v-icon></td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card>
              <v-autocomplete
                class="pt-1"
                hide-details
                dense
                clearable
                outlined
                v-model="BbrToData"
                @click:append-outer="addBbrToData()"
                append-outer-icon="add"
                :items="bundesbruder"
                label="Kontakt hinzufügen"
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-btn text @click="showRechnungerstellenPositionAdd = false">Abbrechen</v-btn>
          <v-spacer></v-spacer>
          <span class="mr-4">Summe: {{ rechnungErstellenPositionAddDataSumme | money }}</span>
          <v-btn text @click="rechnungErstellenPositionAdd()" class="primary">Hinzufügen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showRechnungerstellenVeranstaltungAdd"
      width="60%"
      height="100%"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      persistent
      scrollable
    >
      <v-card class="pa-0 ma-0" height="480px">
        <v-card-title>
          Veranstaltung abrechnen
          <v-spacer></v-spacer>
          <v-btn icon @click="showRechnungerstellenVeranstaltungAdd = false"><v-icon>close</v-icon></v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pa-0 pt-4">
          <v-row>
            <v-col cols="3">
              <v-row>
                <v-col cols="12" class="px-0"
                  ><v-autocomplete
                    @change="changeVeranstaltungDataInput()"
                    hide-details
                    dense
                    :items="veranstaltungen"
                    v-model="rechnungerstellenVeranstaltungAddData.veranstaltung"
                    label="Veranstaltung"
                    outlined
                  ></v-autocomplete
                ></v-col>
                <v-col cols="12" class="px-0"
                  ><v-text-field
                    @input="changeVeranstaltungDataInput()"
                    hide-details
                    dense
                    v-model="rechnungerstellenVeranstaltungAddData.betrag"
                    type="number"
                    label="Betrag"
                    outlined
                  ></v-text-field
                ></v-col>
                <v-col cols="12" class="px-0"
                  ><v-text-field
                    @input="changeVeranstaltungDataInput()"
                    hide-details
                    dense
                    v-model="rechnungerstellenVeranstaltungAddData.betragBegleitung"
                    type="number"
                    label="Betrag Begleitung"
                    outlined
                  ></v-text-field
                ></v-col>
                <v-col cols="12" class="py-0">
                  <v-switch
                    @change="changeVeranstaltungDataInput()"
                    hide-details
                    dense
                    label="Füxe zahlt Fuxenkasse"
                    v-model="rechnungerstellenVeranstaltungAddData.fuxe"
                  ></v-switch>
                  <v-switch
                    @change="changeVeranstaltungDataInput()"
                    hide-details
                    dense
                    label="Begleitungen sind kostenlos"
                    v-model="rechnungerstellenVeranstaltungAddData.begleitungen"
                  ></v-switch>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="9">
              <v-card outlined>
                <v-data-table
                  :items-per-page="rechnungerstellenVeranstaltungAddData.betragArray.length"
                  dense
                  fixed-header
                  height="290"
                  hide-default-footer
                  :items="rechnungerstellenVeranstaltungAddData.betragArray"
                  :headers="headersData"
                >
                  <template v-slot:item="{ item }">
                    <tr>
                      <td width="20px">{{ item.id + 1 }}</td>
                      <td>{{ $filters.user(item.bbr, bbrbbr) }}</td>
                      <td width="150px">
                        <v-text-field
                          dense
                          hide-details
                          class="text-right"
                          prefix="€"
                          v-model="item.betrag"
                          label="Betrag"
                          single-line
                          solo
                          flat
                          reverse
                        ></v-text-field>
                      </td>
                      <td width="20px"><v-icon>delete</v-icon></td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card>
              <v-autocomplete
                class="pt-1"
                hide-details
                dense
                clearable
                outlined
                v-model="BbrToData"
                @click:append-outer="addBbrToData()"
                append-outer-icon="add"
                :items="bundesbruder"
                label="Kontakt hinzufügen"
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-btn text @click="showRechnungerstellenVeranstaltungAdd = false">Abbrechen</v-btn>
          <v-spacer></v-spacer>
          <span class="mr-4">Summe: {{ rechnungErstellenPositionAddDataSumme | money }}</span>
          <v-btn text @click="rechnungErstellenPositionAdd()" class="primary">Hinzufügen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showRechnungerstellenCouleurstrafenAdd"
      width="60%"
      height="100%"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      persistent
      scrollable
    >
      <v-card class="pa-0 ma-0" height="480px">
        <v-card-title>
          Couleurstrafen abrechnen
          <v-spacer></v-spacer>
          <v-btn icon @click="showRechnungerstellenCouleurstrafenAdd = false"><v-icon>close</v-icon></v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pa-0 pt-4">
          <v-row>
            <v-col cols="3">
              <v-row>
                <v-col cols="12" class="px-0"
                  ><v-text-field
                    hide-details
                    dense
                    v-model="rechnungerstellenCouleurstrafenAddData.bezeichnung"
                    label="Bezeichnung"
                    outlined
                  ></v-text-field
                ></v-col>
                <v-col cols="12"><v-btn @click="changeCouleurstrafenDataInput()">hinzufügen</v-btn></v-col>
                <span class="caption"
                  >Bitte beachte: durch Drücken des Button "hinzufügen" werden alle noch nicht berechneten
                  Couleurstrafen der Tabelle hinzugefügt und sofort als berechnet markiert. Das kann nicht rückgängig
                  gemacht werden.</span
                >
              </v-row>
            </v-col>
            <v-col cols="9">
              <v-card outlined>
                <v-data-table
                  :items-per-page="rechnungerstellenCouleurstrafenAddData.betragArray.length"
                  dense
                  fixed-header
                  height="290"
                  hide-default-footer
                  :items="rechnungerstellenCouleurstrafenAddData.betragArray"
                  :headers="headersData"
                >
                  <template v-slot:item="{ item }">
                    <tr>
                      <td width="20px">{{ item.id + 1 }}</td>
                      <td>{{ $filters.user(item.bbr, bbrbbr) }}</td>
                      <td width="150px">
                        <v-text-field
                          dense
                          hide-details
                          class="text-right"
                          prefix="€"
                          v-model="item.betrag"
                          label="Betrag"
                          single-line
                          solo
                          flat
                          reverse
                        ></v-text-field>
                      </td>
                      <td width="20px"><v-icon>delete</v-icon></td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card>
              <v-autocomplete
                class="pt-1"
                hide-details
                dense
                clearable
                outlined
                v-model="BbrToData"
                @click:append-outer="addBbrToData()"
                append-outer-icon="add"
                :items="bundesbruder"
                label="Kontakt hinzufügen"
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-btn text @click="showRechnungerstellenCouleurstrafenAdd = false">Abbrechen</v-btn>
          <v-spacer></v-spacer>
          <span class="mr-4">Summe: {{ rechnungErstellenPositionAddDataSumme | money }}</span>
          <v-btn text @click="rechnungErstellenPositionAdd()" class="primary">Hinzufügen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showSepaDateien" width="80%" :fullscreen="$vuetify.breakpoint.smAndDown" persistent scrollable>
      <v-card>
        <v-card-title>
          Alle Sepa Dateien
          <v-spacer></v-spacer>
          <v-btn icon @click="showSepaDateien = false"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-progress-linear v-if="$vars.loading" indeterminate class="primary--text loader"></v-progress-linear>

        <v-divider></v-divider>

        <v-card-text class="pa-0 ma-0">
          <v-simple-table dense>
            <thead>
              <tr>
                <th></th>
                <th>Datum</th>
                <th>Name</th>
                <th>Summe</th>
                <th>Anzahl</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) of sepaDateien" :key="index">
                <td width="30px">{{ index + 1 }}.</td>
                <td>{{ $filters.date(item.date, "DD.MM.YYYY") }}</td>
                <td>{{ item.filename }}</td>
                <td class="text-right">{{ item.summe | money }}</td>
                <td class="text-center">{{ item.anzahl }}</td>
                <td>
                  <v-btn icon @click="downloadSepa(item)"><v-icon>download</v-icon></v-btn>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
          {{}}
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showSepaDateien = false">Schließen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import papa from "papaparse";
  export default {
    props: ["kasse", "on"],
    data() {
      return {
        showSepaDateien: false,
        showRechnungenVersenden: false,
        rechnungen: [],
        indexRechnung: 0,
        menu1: "",
        menu2: "",
        menu3: "",
        menu4: "",
        showExport: "",
        showStatistik: false,
        filter: {
          von: new Date(new Date().setDate(1)).toISOString().substr(0, 10),
          bis: new Date(new Date(new Date().setDate(1)).setMonth(new Date().getMonth() + 1))
            .toISOString()
            .substr(0, 10),
        },
        showRechnungerstellen: false,
        showRechnungerstellenPositionAdd: false,
        showRechnungerstellenVeranstaltungAdd: false,
        showRechnungerstellenCouleurstrafenAdd: false,
        rechnungErstellenData: {
          bbrbbr: [],
          datum: new Date().toISOString().substr(0, 10),
          zahlbar_bis: new Date(new Date().setDate(new Date().getDate() + 14)).toISOString().substr(0, 10),
          positionen: [],
          rechnungen: [
            {
              positionen: [],
            },
          ],
        },
        rechnungErstellenDataMaske: {
          bbrbbr: [],
          datum: new Date().toISOString().substr(0, 10),
          zahlbar_bis: new Date(new Date().setDate(new Date().getDate() + 14)).toISOString().substr(0, 10),
          freitext:
            "<<Briefanrede>> <<Nachname>>, \n\nhiermit bitte ich Dich die Rechnung <<Rechnungsnummer>> in Höhe von <<Rechnungsbetrag>>€ bis zum <<Zahlbar_bis>> zu überweisen. \n \nMit bundesbrüderlichen Grüßen \n<<Absender Name>>",
          freitext_Sepa:
            "<<Briefanrede>> <<Nachname>>, \n\nhiermit informiere ich Dich, dass die Rechnung <<Rechnungsnummer>> in Höhe von <<Rechnungsbetrag>>€ am <<Zahlbar_bis>> von Deinem Konto abgebucht wird. \n \nMit bundesbrüderlichen Grüßen  \n<<Absender Name>>",
          positionen: [],
          rechnungen: [],
        },
        switchTabelle: {
          positionen: true,
          rechnungen: true,
        },
        headersData: [
          {
            text: "",
            sortable: false,
            value: "id",
          },
          { text: "Bbr", value: "bbr" },
          { text: "Betrag", value: "betrag" },
          { text: "", value: "" },
        ],
        rechnungErstellenPositionAddData: {
          betragArray: [],
        },
        rechnungerstellenVeranstaltungAddData: {
          betragArray: [],
        },
        rechnungerstellenCouleurstrafenAddData: {
          betragArray: [],
        },
        e1: 1,
        showNeueRechnung: false,
        showNeuePosition: false,
        berechneteStrafen: [],
        neueRechnung: {
          bbrbbr: [],
          titel: "",
          datum: new Date().toISOString().substr(0, 10),
          zahlbar_bis: new Date(new Date().setDate(new Date().getDate() + 14)).toISOString().substr(0, 10),
          freitext:
            "<<Briefanrede>> <<Nachname>>, \n\nhiermit bitte ich Dich die Rechnung <<Rechnungsnummer>> in Höhe von <<Rechnungsbetrag>>€ bis zum <<Zahlbar_bis>> zu überweisen. \n \nMit bundesbrüderlichen Grüßen \n<<Absender Name>>",
          positionen: [],
          kasse: this.kasse,
          status: "Entwurf",
        },
        saveNeueRechnung: {
          bbrbbr: [],
          titel: "",
          datum: new Date().toISOString().substr(0, 10),
          zahlbar_bis: new Date(new Date().setDate(new Date().getDate() + 14)).toISOString().substr(0, 10),
          freitext:
            "<<Briefanrede>> <<Nachname>>, \n\nhiermit bitte ich Dich die Rechnung <<Rechnungsnummer>> in Höhe von <<Rechnungsbetrag>>€ bis zum <<Zahlbar_bis>> zu überweisen. \n \nMit bundesbrüderlichen Grüßen \n<<Absender Name>>",
          positionen: [],
          kasse: this.kasse,
          status: "Entwurf",
        },
        headers: [
          { text: "Was", value: "was", align: "left" },
          { text: "Anzahl", value: "anzahl", align: "right" },
          { text: "Betrag", value: "betrag", align: "right" },
        ],
        neuePosition: {},
        neuePositionGruppe: {},
        search: "",
        date: "",
        tab: null,
        tabJahre: null,
        rechnungsJahre: [],
        BbrToData: "",
      };
    },
    computed: {
      bbrbbr() {
        return this.$store.state.bbrbbr.bbrbbr;
      },
      currentBbr() {
        return this.$getCurrentBbr();
      },
      gruppen() {
        return this.$store.state.einstellungen.einstellungen.find((item) => item.id === "mitgliederstatus").status;
      },
      alleRechnungen() {
        return this.$store.getters["rechnungen/rechnungenKasse"](this.kasse);
      },
      kontaktfelder() {
        const felder = [];
        this.$firebase
          .firestore()
          .collection("vereine")
          .doc(this.$vars.verbindung)
          .collection("einstellungen")
          .doc("kontaktfelder")
          .get()
          .then((doc) => {
            if (!doc.exists) {
              console.log("Fehler beim Laden der Kontaktfelder.");
              return ["Fehler beim Laden der Kontaktfelder."];
            } else {
              doc.data().finanzFelder.beitrage.forEach((item) => {
                felder.push({
                  value: item.value,
                  text: item.label,
                });
              });
            }
          })
          .catch((err) => {
            console.log("Error getting document", err);
          });
        return felder;
      },
      veranstaltungen() {
        let veranstaltungen = [];
        let sortable = [];
        this.$store.getters["veranstaltungen/vergangeneVeranstaltungen"].forEach((item) => {
          sortable.push([item, new Date(item.vonDatum)]);
        });
        sortable.sort((a, b) => {
          return b[1] - a[1];
        });
        sortable.forEach((item) => {
          let text =
            new Date(item[0].vonDatum).toLocaleString(["de-de"], {
              weekday: "short",
              day: "numeric",
              month: "numeric",
            }) +
            ": " +
            item[0].titel;
          veranstaltungen.push({
            value: item[0],
            text,
          });
        });
        return veranstaltungen;
      },
      sepaDateien() {
        if (this.$store.state.sepa.sepa.length === 0) {
          this.$store.dispatch("sepa/loadSepa");
        }
        let sepaDateien = this.$store.state.sepa.sepa;
        sepaDateien = sepaDateien.sort(function (a, b) {
          let dateA = new Date(a.date.seconds * 1000);
          let dateB = new Date(b.date.seconds * 1000);
          return dateB - dateA;
        });
        return sepaDateien;
      },
      kontrolleRechnungen() {
        if (this.rechnungErstellenData.rechnungen.length > 0) {
          return this.rechnungErstellenData.rechnungen;
        } else {
          return [{ positionen: [] }];
        }
      },
      bundesbruder() {
        let bbrbbr = [];
        this.$store.state.bbrbbr.bbrbbr.forEach((bbr) => {
          if (bbr.vulgo) {
            bbrbbr.push({
              id: bbr.id,
              value: bbr.id,
              name: bbr.nachname + ", " + bbr.vorname + " (" + bbr.vulgo + ")",
              text: bbr.nachname + ", " + bbr.vorname + " (" + bbr.vulgo + ")",
            });
          } else {
            bbrbbr.push({
              id: bbr.id,
              value: bbr.id,
              name: bbr.nachname + ", " + bbr.vorname,
              text: bbr.nachname + ", " + bbr.vorname,
            });
          }
        });
        return bbrbbr;
      },
      rechnungErstellenPositionAddDataSumme() {
        let summe = 0;
        this.rechnungErstellenPositionAddData.betragArray.forEach((item) => {
          summe =
            parseFloat(summe) + parseFloat(item.betrag) * parseFloat(this.rechnungErstellenPositionAddData.anzahl);
        });
        this.rechnungerstellenVeranstaltungAddData.betragArray.forEach((item) => {
          summe = parseFloat(summe) + parseFloat(item.betrag);
        });
        this.rechnungerstellenCouleurstrafenAddData.betragArray.forEach((item) => {
          summe = parseFloat(summe) + parseFloat(item.betrag);
        });
        return summe;
      },
      rechnungErstellenDataSumme() {
        let summe = 0;
        this.rechnungErstellenData.rechnungen.forEach((item) => {
          summe = parseFloat(summe) + parseFloat(item.summe);
        });
        return summe;
      },
      summe() {
        let summe = 0;
        this.neueRechnung.positionen.forEach((position) => {
          if (position.wer === "gruppe") {
            summe = summe + parseFloat(position.betrag, 2);
          } else {
            summe =
              summe + parseFloat(position.betrag, 2) * parseInt(position.anzahl, 0) * this.neueRechnung.bbrbbr.length;
          }
        });
        return summe;
      },
      formatDatum() {
        if (!this.rechnungErstellenData.datum) return null;
        return new Date(this.rechnungErstellenData.datum).toLocaleString(["de-de"], {
          month: "short",
          weekday: "short",
          day: "numeric",
          year: "2-digit",
        });
      },
      formatDatumVon() {
        if (!this.filter.von) return null;
        return new Date(this.filter.von).toLocaleString(["de-de"], {
          month: "short",
          weekday: "short",
          day: "numeric",
          year: "2-digit",
        });
      },
      formatDatumBis() {
        if (!this.filter.bis) return null;
        return new Date(this.filter.bis).toLocaleString(["de-de"], {
          month: "short",
          weekday: "short",
          day: "numeric",
          year: "2-digit",
        });
      },
      formatZahlbar_bis() {
        if (!this.rechnungErstellenData.zahlbar_bis) return null;
        return new Date(this.rechnungErstellenData.zahlbar_bis).toLocaleString(["de-de"], {
          month: "short",
          weekday: "short",
          day: "numeric",
          year: "2-digit",
        });
      },
      rechnungsKategorienen() {
        let kategorien = [
          {
            status: "Entwurf",
            anzahl: 0,
          },
          {
            status: "Entwurf SEPA",
            anzahl: 0,
          },
          {
            status: "Offen",
            anzahl: 0,
          },
          {
            status: "Versendet",
            anzahl: 0,
          },
          {
            status: "Überfällig",
            anzahl: 0,
          },
          {
            status: "Mahnung",
            anzahl: 0,
          },
          {
            status: "Gemahnt überfällig",
            anzahl: 0,
          },
          {
            status: "Gezahlt",
            anzahl: 0,
          },
          {
            status: "Alle",
            anzahl: 0,
          },
        ];
        let laufvariable = [
          "Entwurf",
          "Entwurf SEPA",
          "Offen",
          "Versendet",
          "Überfällig",
          "Mahnung",
          "Gemahnt überfällig",
          "Gezahlt",
          "Alle",
        ];
        if (this.$store.state.rechnungen.loaded === false) {
          this.$store.dispatch("rechnungen/loadRechnungen");
        }
        this.$store.getters["rechnungen/rechnungenKasse"](this.kasse).forEach((item) => {
          if (this.rechnungsJahre.indexOf(item.rechnung_datum.split("-")[0]) === -1) {
            this.rechnungsJahre.push(item.rechnung_datum.split("-")[0]);
          }
          kategorien[laufvariable.indexOf(item.status)].anzahl++;
          kategorien[laufvariable.indexOf("Alle")].anzahl++;
        });
        kategorien.forEach((item) => {
          if (item.anzahl === 0) {
            kategorien.splice(kategorien.indexOf(item), 1);
          }
        });
        return kategorien;
      },
      positionen() {
        let positionen = {
          sepa: {},
          normal: {},
          sepa_summe: 0,
          normal_summe: 0,
        };
        this.$store.getters["rechnungen/rechnungenKasse"](this.kasse).forEach((item) => {
          if (item.gezahlt_datum) {
            let rechnungsDate = new Date(item.gezahlt_datum.seconds * 1000);
            let von = new Date(this.filter.von);
            let bis = new Date(this.filter.bis);
            if (von <= rechnungsDate && bis >= rechnungsDate) {
              if (item.rechnung_art === "SEPA") {
                item.positionen.forEach((pos) => {
                  if (positionen.sepa[pos.was] === undefined) {
                    positionen.sepa[pos.was] = {
                      bezeichnung: pos.was,
                      betrag: parseFloat(pos.betrag),
                    };
                    positionen.sepa_summe = positionen.sepa_summe + parseFloat(pos.betrag);
                  } else {
                    positionen.sepa[pos.was].betrag += parseFloat(pos.betrag);
                    positionen.sepa_summe = positionen.sepa_summe + parseFloat(pos.betrag);
                  }
                });
              } else {
                item.positionen.forEach((pos) => {
                  if (positionen.normal[pos.was] === undefined) {
                    positionen.normal[pos.was] = {
                      bezeichnung: pos.was,
                      betrag: parseFloat(pos.betrag),
                    };
                    positionen.normal_summe = positionen.normal_summe + parseFloat(pos.betrag);
                  } else {
                    positionen.normal[pos.was].betrag += parseFloat(pos.betrag);
                    positionen.normal_summe = positionen.normal_summe + parseFloat(pos.betrag);
                  }
                });
              }
            }
          }
        });
        return positionen;
      },
    },
    methods: {
      gruppeAdd(bezeichnung) {
        if (this.rechnungErstellenData.bbrbbr === undefined) {
          this.rechnungErstellenData.bbrbbr = [];
        }
        if (bezeichnung === "Alle") {
          this.bbrbbr.forEach((bbr) => {
            this.rechnungErstellenData.bbrbbr.push(bbr.id);
          });
        } else {
          this.bbrbbr.forEach((bbr) => {
            if (bbr.status === bezeichnung) {
              this.rechnungErstellenData.bbrbbr.push(bbr.id);
            }
          });
        }
      },
      rechnungErstellenPositionAdd() {
        let value = {};
        if (this.rechnungErstellenPositionAddData.betragArray.length > 0) {
          value = this.rechnungErstellenPositionAddData;
        }
        if (this.rechnungerstellenVeranstaltungAddData.betragArray.length > 0) {
          value = this.rechnungerstellenVeranstaltungAddData;
          value.bezeichnung = this.rechnungerstellenVeranstaltungAddData.veranstaltung.titel;
        }
        if (this.rechnungerstellenCouleurstrafenAddData.betragArray.length > 0) {
          value = this.rechnungerstellenCouleurstrafenAddData;
          this.berechneteStrafen.forEach((strafe) => {
            this.$store.dispatch("couleurstrafen/updateCouleurstrafData", strafe);
          });
          this.berechneteStrafen = [];
        }
        let posID;
        if (this.rechnungErstellenData.positionen.length === 0) {
          posID = 1;
        } else {
          posID = this.rechnungErstellenData.positionen[this.rechnungErstellenData.positionen.length - 1].id + 1;
        }
        this.rechnungErstellenData.positionen.push({
          id: posID,
          bezeichnung: value.bezeichnung,
          art: value.art,
          rechnungen: [],
          anzahl: value.anzahl,
          kontaktfeld: value.kontaktfeld,
          min: Infinity,
          max: 0,
          summe: 0,
        });
        let posIndex = this.rechnungErstellenData.positionen.findIndex((el) => el.id === posID);
        value.betragArray.forEach((beitrag) => {
          if (beitrag.betrag > 0) {
            let beitragData = {
              id: posID,
              bbr: beitrag.bbr,
              bezeichnung: value.bezeichnung,
              anzahl: value.anzahl,
              betrag: beitrag.betrag,
              summe: parseFloat(value.anzahl) * parseFloat(beitrag.betrag),
            };
            // Hinzufügen zu Positionen
            this.rechnungErstellenData.positionen[posIndex].rechnungen.push(beitragData);
            this.rechnungErstellenData.positionen[posIndex].summe =
              parseFloat(this.rechnungErstellenData.positionen[posIndex].summe) + parseFloat(beitragData.summe);
            if (beitragData.summe < this.rechnungErstellenData.positionen[posIndex].min) {
              this.rechnungErstellenData.positionen[posIndex].min = beitragData.summe;
            }
            if (beitragData.summe > this.rechnungErstellenData.positionen[posIndex].max) {
              this.rechnungErstellenData.positionen[posIndex].max = beitragData.summe;
            }
            // Hinzufügen zu Rechnungen
            let rechnungIndex = this.rechnungErstellenData.rechnungen.findIndex((el) => el.bbrID === beitragData.bbr);
            if (rechnungIndex === -1) {
              this.rechnungErstellenData.rechnungen.push({
                bbrID: beitragData.bbr,
                summe: 0,
                positionen: [],
              });
              rechnungIndex = this.rechnungErstellenData.rechnungen.findIndex((el) => el.bbrID === beitragData.bbr);
            }
            this.rechnungErstellenData.rechnungen[rechnungIndex].positionen.push(beitragData);
            this.rechnungErstellenData.rechnungen[rechnungIndex].summe =
              parseFloat(this.rechnungErstellenData.rechnungen[rechnungIndex].summe) + parseFloat(beitragData.summe);
          }
        });
        this.showRechnungerstellenPositionAdd = false;
        this.showRechnungerstellenVeranstaltungAdd = false;
        this.showRechnungerstellenCouleurstrafenAdd = false;
        this.rechnungErstellenPositionAddData = { betragArray: [] };
        this.rechnungerstellenVeranstaltungAddData = { betragArray: [] };
        this.rechnungerstellenCouleurstrafenAddData = { betragArray: [] };
      },
      addBbrToData() {
        this.rechnungErstellenData.bbrbbr.push(this.BbrToData);
        this.BbrToData = "";
      },
      changePositionDataInput(art) {
        let betrag;
        let value = this.rechnungErstellenPositionAddData.kontaktfeld;
        this.rechnungErstellenPositionAddData.betragArray = [];
        let id = 0;
        this.rechnungErstellenData.bbrbbr.forEach((bbr) => {
          if (art === "kontaktfeld") {
            betrag = parseFloat(this.$store.getters["bbrbbr/bbr"](bbr)[value]);
          }
          if (art === "betrag") {
            betrag = this.rechnungErstellenPositionAddData.betrag;
          }
          if (art === "null") {
            betrag = 0;
          }
          if (!betrag) {
            betrag = 0;
          }
          this.rechnungErstellenPositionAddData.betragArray.push({
            id,
            bbr,
            betrag,
          });
          id++;
        });
      },
      changeVeranstaltungDataInput() {
        this.rechnungerstellenVeranstaltungAddData.betragArray = [];
        let id = 0;
        let betragFuxenkasse = 0;
        this.rechnungerstellenVeranstaltungAddData.veranstaltung.anmeldungen.forEach((anmeldung) => {
          let bbr = this.$store.getters["bbrbbr/bbr"](anmeldung);
          let betrag = this.rechnungerstellenVeranstaltungAddData.betrag;
          if (bbr.status === "Fux") {
            if (this.rechnungerstellenVeranstaltungAddData.fuxe) {
              betragFuxenkasse = parseFloat(betragFuxenkasse) + parseFloat(betrag);
              betrag = 0;
            }
          }
          if (!this.rechnungerstellenVeranstaltungAddData.begleitungen) {
            this.rechnungerstellenVeranstaltungAddData.veranstaltung.weitereAnmeldungen.forEach((weitereAnmeldung) => {
              if (weitereAnmeldung.angemeldetVon === anmeldung) {
                betrag = parseFloat(betrag) + parseFloat(this.rechnungerstellenVeranstaltungAddData.betragBegleitung);
              }
            });
          }
          if (betrag > 0) {
            this.rechnungerstellenVeranstaltungAddData.betragArray.push({
              id,
              bbr: anmeldung,
              betrag,
            });
          }
          id++;
        });
        if (betragFuxenkasse > 0) {
          this.rechnungerstellenVeranstaltungAddData.betragArray.push({
            id,
            bbr: "1VHmwi95sFWuvyhLjR9I",
            betrag: betragFuxenkasse,
          });
        }
      },
      changeCouleurstrafenDataInput() {
        if (this.$store.state.couleurstrafen.couleurstrafen.length === 0) {
          this.$store.dispatch("couleurstrafen/loadCouleurstrafen");
        }
        this.rechnungerstellenCouleurstrafenAddData.betragArray = [];
        let id = 0;
        this.berechnteStrafen = [];
        this.rechnungErstellenData.bbrbbr.forEach((bbr) => {
          let betrag = 0;
          this.$store.state.couleurstrafen.couleurstrafen.forEach((item) => {
            item.strafen.forEach((strafe) => {
              if (strafe.wer === bbr && strafe.bezahlt === false) {
                betrag += parseFloat(strafe.betrag);
                strafe.bezahlt = true;
                this.berechneteStrafen.push(item);
              }
            });
          });
          this.rechnungerstellenCouleurstrafenAddData.betragArray.push({
            id,
            bbr,
            betrag,
          });
          id++;
        });
      },
      deleteRechnungErstellenPosition(item) {
        let index = this.rechnungErstellenData.positionen.indexOf(item);
        this.rechnungErstellenData.positionen.splice(index, 11);
        this.rechnungErstellenData.rechnungen.forEach((rechnung) => {
          rechnung.positionen.forEach((position) => {
            if (position.id === item.id) {
              rechnung.summe = parseFloat(rechnung.summe) - parseFloat(position.anzahl) * parseFloat(position.betrag);
              rechnung.positionen.splice(rechnung.positionen.indexOf(position), 1);
            }
          });
        });
      },
      deleteRechnungErstellenRechnung(item) {
        let index = this.rechnungErstellenData.rechnungen.indexOf(item);
        this.rechnungErstellenData.rechnungen.splice(index, 1);
        item.positionen.forEach((itemPosition) => {
          let posIndex = this.rechnungErstellenData.positionen.findIndex((el) => el.id === itemPosition.id);
          this.rechnungErstellenData.positionen[posIndex].rechnungen.splice(
            this.rechnungErstellenData.positionen[posIndex].rechnungen.indexOf(itemPosition),
            1
          );
          let posBetrag = parseFloat(itemPosition.anzahl) * parseFloat(itemPosition.betrag);
          this.rechnungErstellenData.positionen[posIndex].summe =
            parseFloat(this.rechnungErstellenData.positionen[posIndex].summe) - parseFloat(posBetrag);
          if (
            posBetrag === this.rechnungErstellenData.positionen[posIndex].min ||
            posBetrag === this.rechnungErstellenData.positionen[posIndex].max
          ) {
            let min = Infinity;
            let max = 0;
            this.rechnungErstellenData.positionen[posIndex].rechnungen.forEach((rechnung) => {
              if (rechnung.anzahl * rechnung.betrag < min) {
                min = rechnung.anzahl * rechnung.betrag;
              }
              if (rechnung.anzahl * rechnung.betrag > max) {
                max = rechnung.anzahl * rechnung.betrag;
              }
            });
          }
        });
      },
      downloadSepa(item) {
        let xmltext = item.xml;
        let filename = item.filename;
        // Generieren und Download der Datei
        let pom = document.createElement("a");
        pom = document.createElement("a");
        let bb = new Blob([xmltext], { type: "text/plain" });
        pom.setAttribute("href", window.URL.createObjectURL(bb));
        pom.setAttribute("download", filename);
        pom.dataset.downloadurl = ["text/plain", pom.download, pom.href].join(":");
        pom.draggable = true;
        pom.classList.add("dragout");
        pom.click();
      },
      exportData() {
        var csv = papa.unparse(this.$store.getters["rechnungen/rechnungenKasse"](this.kasse), {
          header: true,
          encoding: "UTF-8",
        });
        const anchor = document.createElement("a");
        anchor.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
        anchor.target = "_blank";
        anchor.download = "Export-Rechnungen-Bierkasse.csv";
        anchor.click();
      },
      addGruppe(item) {
        if (item === "Aktive") {
          this.$store.getters["bbrbbr/bbrStatus"]("Fux").forEach((bbr) => {
            this.neueRechnung.bbrbbr.push(bbr.id);
          });
          this.$store.getters["bbrbbr/bbrStatus"]("Aktiver").forEach((bbr) => {
            this.neueRechnung.bbrbbr.push(bbr.id);
          });
          this.$store.getters["bbrbbr/bbrStatus"]("Inaktiver in locum").forEach((bbr) => {
            this.neueRechnung.bbrbbr.push(bbr.id);
          });
          this.$store.getters["bbrbbr/bbrStatus"]("Inaktiver extra locum").forEach((bbr) => {
            this.neueRechnung.bbrbbr.push(bbr.id);
          });
        }
        if (item === "AHAH") {
          this.$store.getters["bbrbbr/bbrStatus"]("Alter Herr").forEach((bbr) => {
            this.neueRechnung.bbrbbr.push(bbr.id);
          });
        }
      },
      ersetzeText(text, rechnung) {
        let summe = 0;
        rechnung.positionen.forEach((position) => {
          summe = parseFloat(summe) + parseFloat(position.betrag);
        });
        text = text.replace("<<Rechnungstitel>>", rechnung.rechnung_titel);
        text = text.replace(
          "<<Rechnungsdatum>>",
          new Date(rechnung.rechnung_datum).toLocaleString(["de-de"], {
            month: "short",
            day: "2-digit",
            year: "numeric",
          })
        );
        text = text.replace("<<Rechnungsnummer>>", rechnung.rechnungsnummer);
        text = text.replace("<<Briefanrede>>", this.$store.getters["bbrbbr/bbr"](rechnung.bbrID).briefanrede);
        text = text.replace("<<Vorname>>", this.$store.getters["bbrbbr/bbr"](rechnung.bbrID).vorname);
        text = text.replace("<<Nachname>>", this.$store.getters["bbrbbr/bbr"](rechnung.bbrID).nachname);
        text = text.replace("<<Rechnungsbetrag>>", summe.toFixed(2));
        text = text.replace(
          "<<Absender Name>>",
          this.$store.getters["bbrbbr/bbr"](this.currentBbr).vorname +
            " " +
            this.$store.getters["bbrbbr/bbr"](this.currentBbr).nachname
        );
        text = text.replace(
          "<<Zahlbar_bis>>",
          new Date(rechnung.rechnung_zahlbar_bis).toLocaleString(["de-de"], {
            month: "short",
            day: "2-digit",
            year: "numeric",
          })
        );
        return text;
      },
      rechnungErstellen() {
        console.log("rechnung stellen");
        let rechnungen = [];
        this.rechnungErstellenData.rechnungen.forEach((rechnung) => {
          let bbr = this.$store.getters["bbrbbr/bbr"](rechnung.bbrID);
          let positionen = [];
          rechnung.positionen.forEach((item) => {
            positionen.push({
              betrag: item.summe,
              positionen: [],
              was: item.bezeichnung,
            });
          });
          console.log(this.kasse);
          if (bbr.sepa === undefined) {
            console.log(bbr);
          }
          let kasseCorrect;
          if (bbr.sepa) {
            kasseCorrect = bbr.sepa[this.kasse];
          }
          console.log(kasseCorrect);
          if (
            kasseCorrect &&
            bbr.iban !== "" &&
            bbr.bic !== "" &&
            bbr.mandatsreferenz !== "" &&
            bbr.mandatUnterschriftsdatum !== "" &&
            bbr.kontoinhaber !== ""
          ) {
            rechnungen.push({
              bbrID: bbr.id,
              rechnung_art: "SEPA",
              rechnung_titel: this.rechnungErstellenData.titel,
              rechnung_datum: this.rechnungErstellenData.datum,
              rechnung_zahlbar_bis: this.rechnungErstellenData.zahlbar_bis,
              rechnung_freitext: this.rechnungErstellenData.freitext_Sepa,
              positionen: positionen,
              kasse: this.kasse,
              status: "Entwurf SEPA",
            });
          } else {
            rechnungen.push({
              bbrID: bbr.id,
              rechnung_art: "Normal",
              rechnung_titel: this.rechnungErstellenData.titel,
              rechnung_datum: this.rechnungErstellenData.datum,
              rechnung_zahlbar_bis: this.rechnungErstellenData.zahlbar_bis,
              rechnung_freitext: this.rechnungErstellenData.freitext,
              positionen: positionen,
              kasse: this.kasse,
              status: "Entwurf",
            });
          }
        });
        let rechnungsnummerData;
        this.$firebase
          .firestore()
          .collection("vereine")
          .doc(this.$vars.verbindung)
          .collection("einstellungen")
          .doc("rechnungsnummer")
          .get()
          .then((snapshot) => {
            rechnungsnummerData = snapshot.data();
          })
          .then(() => {
            rechnungen.forEach((neueRechnung) => {
              let a = "0000" + rechnungsnummerData.rechnungsnummer[2]++;
              let b = a.substr(a.length - 4, 4);
              rechnungsnummerData.rechnungsnummer[0] = new Date().getFullYear();
              neueRechnung.rechnungsnummer = rechnungsnummerData.rechnungsnummer[0] + "-" + b;
              neueRechnung.rechnung_freitext = this.ersetzeText(neueRechnung.rechnung_freitext, neueRechnung);
              this.$store.dispatch("rechnungen/createRechnung", neueRechnung);
            });
          })
          .then(() => {
            let rechnungsnummerNeu = {
              rechnungsnummer: [
                rechnungsnummerData.rechnungsnummer[0],
                rechnungsnummerData.rechnungsnummer[1],
                rechnungsnummerData.rechnungsnummer[2],
              ],
            };
            this.$firebase
              .firestore()
              .collection("vereine")
              .doc(this.$vars.verbindung)
              .collection("einstellungen")
              .doc("rechnungsnummer")
              .update(rechnungsnummerNeu)
              .then(() => {
                this.$vars.loading = false;
                this.fortschritt = 100;
                this.showRechnungenGenerieren = false;
              })
              .catch((error) => {
                console.log(error);
              });
          })
          .then(() => {
            this.showRechnungerstellen = false;
            this.e1 = 1;
            this.rechnungErstellenData = this.rechnungErstellenDataMaske;
          });
      },
      addPosition() {
        this.neuePosition.wer = "alle";
        this.neueRechnung.positionen.push(this.neuePosition);
        this.neuePosition = {};
      },
      addGroupPosition() {
        let summe = 0;
        let min = Infinity;
        let max = 0;
        this.neuePositionGruppe.positionen.forEach((position) => {
          summe += position.anzahl * position.betrag;
          if (min > position.betrag) {
            min = position.betrag;
          }
          if (max < position.betrag) {
            max = position.betrag;
          }
        });
        let neuePosition = {
          wer: "gruppe",
          anzahl: this.neuePositionGruppe.positionen[0].anzahl,
          was: this.neuePositionGruppe.was,
          betrag: summe,
          positionen: this.neuePositionGruppe.positionen,
          min,
          max,
        };
        this.neueRechnung.positionen.push(neuePosition);
        this.neuePositionGruppe = {};
        this.showNeuePosition = false;
      },
      addPositionGruppe() {
        this.neuePositionGruppe.positionen = [];
        this.neueRechnung.bbrbbr.forEach((bbr) => {
          let betrag;
          if (this.$store.getters["bbrbbr/bbr"](bbr)[this.neuePositionGruppe.kontaktfeld]) {
            betrag = parseFloat(this.$store.getters["bbrbbr/bbr"](bbr)[this.neuePositionGruppe.kontaktfeld]);
          } else {
            betrag = 0;
          }
          this.neuePositionGruppe.positionen.push({
            was: this.neuePositionGruppe.was,
            anzahl: this.neuePositionGruppe.anzahl,
            wer: bbr,
            betrag: betrag,
          });
        });
        this.$forceUpdate();
      },
      removePosition() {
        this.neueRechnung.positionen.splice(this.neueRechnung.positionen.indexOf(this.neuePosition), 1);
      },
    },
    // mounted () {
    //   console.log(this.$route)
    // }
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// rechnungen.vue?7a081821